import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'

import { InputField } from '../../../ui/components/index.js'
import GenericSelect from '../../reutilizables/genericSelect/GenericSelect'
import { buscarUnidad } from '../../servicios/publicacionesService'
import styles from './CambioPrecio.module.css'

const MAX_PORC_CAMBIO = 99
const PRECIO_MAYORISTA_ID_TEM = 10000000

const CambioPrecio = ({
  idPublicacion,
  value: precioUnitario,
  onChangeState,
  onChangePorcentaje,
  isDisabled,
  alicuota,
  precioMayorista,
  cantDisponible,
  onChange,
  aPedido,
  cantMinPedido,
  capacidadMax,
  cantTiempoProd,
  periodoTiempoProd,
  periodosProduccion
}) => {
  const [id, setId] = useState(0)
  const [precioOriginal, setPrecioOriginal] = useState(0)
  const [porcCambio, setPorcCambio] = useState(0)
  const [importeCambio, setImporteCambio] = useState(0)
  const [cantidadDisponibleCambio, setCantidadDisponibleCambio] = useState(0)
  const [preciosMayorista, setPreciosMayorista] = useState([])
  const [unidades, setUnidades] = useState([])

  const handleChangePorcentaje = (e) => {
    const porcCambio = e.target.value
    let valor = isNaN(porcCambio) || porcCambio === '' ? 0 : parseFloat(porcCambio)
    if (valor < 0) {
      valor = 0
    }
    if (valor > MAX_PORC_CAMBIO) {
      valor = MAX_PORC_CAMBIO
    }
    setPorcCambio(valor)
    setImporteCambio(precioOriginal)
    const nuevoPrecio =
      valor === 0 ? precioOriginal : precioOriginal + (valor * precioOriginal) / 100
    onChangeState('precioUnitario', nuevoPrecio)
    onChange(e, 'calc', e.target.value)
  }

  const handleChangeImporte = (e) => {
    const importe = e.target.value
    let nuevoPrecio = isNaN(importe) || importe === '' ? precioOriginal : parseFloat(importe)
    if (nuevoPrecio <= 0) {
      nuevoPrecio = precioOriginal
    }
    setImporteCambio(nuevoPrecio)
    setPorcCambio(0)
    onChangeState('precioUnitario', nuevoPrecio)
    onChange(e, 'calc', e.target.value)
  }

  const handleChangeCantidadDisponible = (e) => {
    const cantidad = e.target.value
    const nuevaCantidad = cantidad === '' ? Number(cantDisponible) || 0 : Number(cantidad)
    setCantidadDisponibleCambio(nuevaCantidad)
    onChangeState('cantDisponible', nuevaCantidad)
    onChange(e, 'num', nuevaCantidad)
  }

  const handleChangeCampoNumerico = (e, campo) => {
    const valor = e.target.value
    const nuevoValor = valor === '' ? 0 : Number(valor)
    onChangeState(campo, nuevoValor)
    onChange(e, 'num', nuevoValor)
  }

  useEffect(() => {
    if (idPublicacion !== id || (precioOriginal === 0 && precioUnitario !== undefined)) {
      setId(idPublicacion)
      setPorcCambio(0)
      if (precioUnitario !== undefined) {
        setPrecioOriginal(precioUnitario)
        setImporteCambio(precioUnitario)
      } else {
        setImporteCambio(0)
      }
      setCantidadDisponibleCambio(Number(cantDisponible) || 0)
    }
  }, [idPublicacion, id, precioOriginal, precioUnitario, cantDisponible, onChangePorcentaje])

  const buscarUnidades = async () => {
    const unidadesRtn = await buscarUnidad()
    setUnidades(unidadesRtn.data)
  }

  useEffect(() => {
    unidades.length === 0 && buscarUnidades()
    setPreciosMayorista(precioMayorista)
  }, [precioMayorista])

  let disabled
  if (isDisabled) {
    disabled = 'disabled'
  }
  const handleChangeAlicuota = (alicuota) => {
    onChangeState('alicuota', isNaN(alicuota) || alicuota === '' ? 0 : parseFloat(alicuota))
  }

  const onChangeMayorista = ({ target }, idPublicacionPrecioMayorista) => {
    const { value, name } = target
    const valueInt = parseInt(value)
    let precios
    if (precioMayorista.length === 1) {
      precios = [{ ...precioMayorista[0], [name]: valueInt > 0 ? valueInt : 0 }]
    } else {
      precios = preciosMayorista.map((element) => {
        return element.idPublicacionPrecioMayorista === idPublicacionPrecioMayorista
          ? {
              ...element,
              [name]: valueInt > 0 ? valueInt : 0
            }
          : element
      })
    }
    onChangeState('preciosMayorista', precios)
    setPreciosMayorista(precios)

    onChange(
      {
        currentTarget: {
          name: 'preciosMayorista',
          value: precios
        }
      },
      'calc',
      precios
    )
  }

  const agregarPrecioMayorista = () => {
    const primeraUnidad = preciosMayorista && preciosMayorista.length > 0 ? preciosMayorista[0] : {}

    const nuevo = {
      idPublicacionPrecioMayorista: Math.floor(Math.random() * PRECIO_MAYORISTA_ID_TEM),
      idPublicacion: 0,
      cantidad: 0,
      precio: 0,
      idUnidadMedida: primeraUnidad.idUnidadMedida ?? unidades[0]?.idUnidadMedida ?? 0,
      unidad: primeraUnidad.unidad ?? unidades[0]?.unidad ?? ''
    }

    const nuevos = [...preciosMayorista, nuevo]

    setPreciosMayorista(nuevos)
    onChangeState('preciosMayorista', nuevos)
  }

  const eliminarPrecioMayorista = (idPublicacionPrecioMayorista) => {
    const nuevos = preciosMayorista.filter(
      (fila) => fila.idPublicacionPrecioMayorista !== idPublicacionPrecioMayorista
    )
    setPreciosMayorista(nuevos)
    onChangeState('preciosMayorista', nuevos)
  }

  return (
    <div className={styles.contenedor}>
      <div className={styles.flexContainer}>
        <div className={`${styles.inputGroup} ${styles.campoCorto}`}>
          <span>Por porcentaje</span>
          <div className={styles.flexRow}>
            <InputField
              type="number"
              name="porcCambio"
              value={porcCambio}
              onChange={(e) => handleChangePorcentaje(e)}
              disabled={disabled}
            />
            <i className={`fa fa-percent ${styles.simboloPorcentaje}`} aria-hidden="true" />
          </div>
        </div>
        <div className={`${styles.inputGroup} ${styles.campoImporte}`}>
          <span>Por Importe</span>
          <div className={styles.flexRow}>
            <InputField
              type="number"
              name="importeCambio"
              value={importeCambio}
              onChange={(e) => handleChangeImporte(e)}
              disabled={disabled}
            />
            <i className={`fa fa-dollar ${styles.simboloDolar}`} aria-hidden="true" />
          </div>
        </div>
        <div className={`${styles.inputGroup} ${styles.campoCorto}`}>
          <span>Alícuota</span>
          <InputField
            type="number"
            name="alicuota"
            value={alicuota}
            onChange={(e) => (
              handleChangeAlicuota(e.target.value),
              onChange(e, 'calc', e.target.value)
            )}
            disabled={disabled}
            step="0.1"
          />
        </div>
      </div>
      <div className={styles.cantDisponibleRow}>
        {!aPedido ? (
          <div className={styles.cantDisponibleField}>
            <InputField
              type="number"
              name="cantDisponible"
              value={cantidadDisponibleCambio}
              onChange={(e) => handleChangeCantidadDisponible(e)}
              label="Cantidad Disponible:"
            />
          </div>
        ) : (
          <>
            <div className={styles.cantDisponibleField}>
              <InputField
                type="number"
                name="cantMinPedido"
                value={cantMinPedido ?? 0}
                onChange={(e) => handleChangeCampoNumerico(e, 'cantMinPedido')}
                label="Cantidad Mínima:"
              />
            </div>
            <div className={styles.cantDisponibleField}>
              <InputField
                type="number"
                name="capacidadMax"
                value={capacidadMax ?? 0}
                onChange={(e) => handleChangeCampoNumerico(e, 'capacidadMax')}
                label="Cantidad Máxima:"
              />
            </div>
            <div>
              <InputField
                type="number"
                name="cantTiempoProd"
                value={cantTiempoProd ?? 0}
                onChange={(e) => handleChangeCampoNumerico(e, 'cantTiempoProd')}
                label="Cant. Tiempo Prod.:"
              />
            </div>
            <div>
              <GenericSelect
                name="periodoTiempoProd"
                value={periodoTiempoProd ?? 0}
                onChange={(value) =>
                  handleChangeCampoNumerico(
                    { target: { name: 'periodoTiempoProd', value } },
                    'periodoTiempoProd'
                  )
                }
                options={periodosProduccion.map((periodo) => ({
                  value: periodo.id,
                  label: periodo.periodo
                }))}
                placeholder="Seleccionar"
              />
            </div>
          </>
        )}
      </div>
      <div>
        <div className={styles.mayoristaTitulo}>Precio mayorista</div>
        <button
          className={`btn btn-primary ${styles.btnAgregar}`}
          type="button"
          onClick={agregarPrecioMayorista}
        >
          + Agregar precio mayorista
        </button>
        {preciosMayorista?.length > 0 &&
          preciosMayorista.map((mayorista, index) => (
            <div className={styles.rowMayorista} key={index}>
              <div className={`${styles.inputGroup} ${styles.campoMayorista}`}>
                <span>Cantidad</span>
                <InputField
                  type="number"
                  name="cantidad"
                  value={mayorista?.cantidad || 0}
                  onChange={(e) => onChangeMayorista(e, mayorista.idPublicacionPrecioMayorista)}
                  onFocus={(e) => e.target.select()}
                />
              </div>
              <div className={`${styles.inputGroup} ${styles.campoMayorista}`}>
                <span>Precio Unitario</span>
                <InputField
                  type="number"
                  name="precio"
                  value={mayorista.precio || 0}
                  onChange={(e) => onChangeMayorista(e, mayorista.idPublicacionPrecioMayorista)}
                  onFocus={(e) => e.target.select()}
                />
              </div>
              <div className={`${styles.inputGroup} ${styles.campoUnidad}`}>
                <span>Unidad</span>
                <GenericSelect
                  name="idUnidadMedida"
                  value={mayorista.idUnidadMedida || 0}
                  onChange={(value) =>
                    onChangeMayorista(
                      { target: { name: 'idUnidadMedida', value } },
                      mayorista.idPublicacionPrecioMayorista
                    )
                  }
                  options={unidades.map((unidad) => ({
                    value: unidad.idUnidadMedida,
                    label: unidad.nombre
                  }))}
                  placeholder="Seleccionar"
                />
              </div>
              <div className={styles.celdaAccion}>
                <button
                  type="button"
                  title="Eliminar precio mayorista"
                  className="btn btn-danger"
                  onClick={() => eliminarPrecioMayorista(mayorista.idPublicacionPrecioMayorista)}
                >
                  <i className="bi bi-trash" />
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

CambioPrecio.propTypes = {
  idPublicacion: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  onChangeState: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangePorcentaje: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  alicuota: PropTypes.number.isRequired,
  cantDisponible: PropTypes.number.isRequired,
  cantMinPedido: PropTypes.number,
  capacidadMax: PropTypes.number,
  aPedido: PropTypes.bool,
  precioMayorista: PropTypes.arrayOf(
    PropTypes.shape({
      cantidad: PropTypes.number.isRequired,
      precio: PropTypes.number.isRequired,
      unidad: PropTypes.string.isRequired
    })
  ),
  cantTiempoProd: PropTypes.number,
  periodoTiempoProd: PropTypes.number,
  periodosProduccion: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      periodo: PropTypes.string.isRequired
    })
  )
}

export default CambioPrecio
